import { store } from "./state/store.js";
const ROUTES = [
    "home",
    "quickcal",
    "play",
    "designer",
    "visualizer",
    "diagnostics",
    "rehearse",
];
export function initRouter() {
    const apply = () => {
        let hash = location.hash
            .replace(/^#\/?/, "")
            .replace(/\/+$/, "")
            .trim();
        // Legacy alias: the old "Record" screen is now Word Rehearsal.
        if (hash === "record")
            hash = "rehearse";
        store.route.set(ROUTES.includes(hash) ? hash : "home");
    };
    window.addEventListener("hashchange", apply);
    apply();
}
export function navigate(route) {
    location.hash = `#/${route}`;
}
export function onRoute(fn) {
    return store.route.subscribe(fn);
}
